//import { UserService } from 'src/app/services/user.service';
import { SimpleChanges, OnInit, ChangeDetectorRef } from '@angular/core';
import { WizardComponent } from 'angular-archwizard';
import { MatDialog, MatSnackBar } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
//Prueba NGRX STORE
import { Store } from '@ngrx/store';
import { FilemakerService } from 'src/app/services/filemaker.service';
import { CertificadosService } from 'src/app/services/certificados.service';
import { Tipo_propiedadComponent } from '../../formulario/tipo_propiedad/tipo_propiedad.component';
import { CipComponent } from '../../formulario/cip/cip.component';
var Navbar_certComponent = /** @class */ (function () {
    function Navbar_certComponent(_certService, _changeDetectionRef, dialog, store, spinner, snackBar, filemaker) {
        this._certService = _certService;
        this._changeDetectionRef = _changeDetectionRef;
        this.dialog = dialog;
        this.store = store;
        this.spinner = spinner;
        this.snackBar = snackBar;
        this.filemaker = filemaker;
        this.tabs = [];
        this.actualForm = [];
        this.tempWizard = [];
        this.start = 0;
        this.end = 0;
        this.limit = 4;
        this.actual = 0;
        this.data = [];
        // borradorId;
        //infoBorrador;
        //formulariofinal;
        this.items = [
            {
                name: 'Prueba 1',
                component: Tipo_propiedadComponent
            },
            {
                name: 'Prueba 2',
                component: CipComponent
            }
        ];
        this.wizardSteps = [];
    }
    Navbar_certComponent.prototype.ngOnInit = function () {
    };
    Navbar_certComponent.prototype.ngDoCheck = function () {
        this._changeDetectionRef.detectChanges();
    };
    Navbar_certComponent.prototype.ngOnChanges = function (changes) {
        for (var propName in changes) {
            var change = changes[propName];
            var curVal = JSON.stringify(change.currentValue);
            var prevVal = JSON.stringify(change.previousValue);
        }
        this.getPasos(this.form);
        //this.borradorId = sessionStorage.getItem("borrador");
    };
    Navbar_certComponent.prototype.getPasos = function (id) {
        var _this = this;
        this.spinner.show();
        this.wizardSteps = [];
        this.data = [];
        this.actual = 0;
        this.start = 0;
        this.end = 0;
        this.limit = 4;
        this._certService.getPasos().subscribe(function (response) {
            console.log(JSON.stringify(response));
            var _loop_1 = function (x) {
                if (response.forms[x].name == id) {
                    console.log(response.forms[x]);
                    var promise = new Promise(function (resolve, reject) {
                        for (var t = 0; t < response.forms[x].tabs.length; t++) {
                            _this.wizardSteps.push(response.forms[x].tabs[t]);
                        }
                        resolve(_this.wizardSteps);
                    });
                    promise.then(function () {
                        for (var i = 0; i < 4; i++) {
                            _this.data.push(_this.wizardSteps[i]);
                        }
                        _this.start = 0;
                        _this.end = _this.start + _this.limit;
                    });
                }
            };
            for (var x = 0; x < response.forms.length; x++) {
                _loop_1(x);
            }
            _this.spinner.hide();
        }, function (error) {
            console.log("Error", error);
            _this.spinner.hide();
        });
    };
    Navbar_certComponent.prototype.next = function () {
        if (this.actual + 1 == this.wizardSteps.length) {
            return;
        }
        this.actual++;
        if (this.actual == this.end - 1 && this.actual != this.wizardSteps.length - 1) {
            this.data.push(this.wizardSteps[this.actual + 1]);
            this.data.splice(0, 1);
            this.end++;
            this.start++;
        }
    };
    Navbar_certComponent.prototype.back = function () {
        if (this.actual == 0 && this.start == 0) {
            return;
        }
        this.actual--;
        if (this.actual == this.start && this.start > 0) {
            this.data.unshift(this.wizardSteps[this.start - 1]);
            this.data.splice(this.data.length - 1, 1);
            this.end--;
            this.start--;
        }
    };
    return Navbar_certComponent;
}());
export { Navbar_certComponent };
